import React, { forwardRef } from 'react';
import { react2panel } from 'common/util/react2panel';
// eslint-disable-next-line import/no-cycle -- QBK can render other QBKs
import { QueryBlockReact } from 'common/query-builder/query-block';
import { QueryBlockParams } from './types';

// forcing deferred usage since there are valid circular dependencies in QB
export const QueryBlockEl = react2panel("mp-query-block", forwardRef<HTMLDivElement, QueryBlockParams>((props, ref) => <QueryBlockReact ref={ref} {...props} />));